<template>
  <div  id="login" >
    {{ $t('notfound.lblTitle') }}
    <p class="fWB">{{ $t('notfound.lblPageNotFound') }}</p>
    <ul class="normalList">
      <li>{{ $t('notfound.lblPageNotFoundCause1') }}</li>
      <li>{{ $t('notfound.lblPageNotFoundCause2') }}</li>
      <li>{{ $t('notfound.lblPageNotFoundCause3') }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Notfound',
  created() {
    this.$i18n.locale = ['ja', 'en'].includes(this.$route.query.lang) ? this.$route.query.lang : 'ja'
  }
}
</script>
